import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router-dom';
import UserIcon from '../../../assets/icons/ic-user-black.svg';
import Notification from './NotificationDropdown';
import HelpIcon from '@material-ui/icons/Help';
var IconBar = function (props) {
    var history = useHistory();
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var onSignOut = function (event) {
        event.preventDefault();
        props.onUserLogout();
    };
    var handlePublisherManual = function (event) {
        event.preventDefault();
        history.push('/publisher-manual');
    };
    var handleRedirect = function (path) {
        history.push(path);
    };
    return (React.createElement("div", { className: "right-bar" },
        React.createElement(IconButton, { "aria-controls": "simple-menu", "aria-haspopup": "true", style: { color: "#FFF" }, className: "root-avatar", onClick: handlePublisherManual },
            React.createElement(HelpIcon, null)),
        React.createElement(Notification, null),
        React.createElement(Button, { "aria-controls": "simple-menu", "aria-haspopup": "true", className: "root-avatar", onClick: handleClick },
            React.createElement("div", { className: "user-icon" },
                React.createElement("img", { src: UserIcon, alt: "ic-user" }))),
        React.createElement(Menu, { id: "simple-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose },
            React.createElement(MenuItem, { className: "menu-item", onClick: function () { return handleRedirect("/api-setting"); } }, "API Setting"),
            props.enabledInventory ? React.createElement(MenuItem, { className: "menu-item", onClick: function () { return handleRedirect("/inventories"); } }, "Inventory") : null,
            React.createElement(MenuItem, { className: "menu-item", onClick: onSignOut }, "Sign Out"))));
};
export default IconBar;
